import type { GetPositionsRow, PositionAccountingDto } from '@morfi/backend-sdk-v2/client';

/** Maps indexed accounting fields without coercing or supplying defaults. */
export function positionAccountingDtoFromRow(
  row: GetPositionsRow | undefined,
): PositionAccountingDto | null {
  if (row === undefined) return null;
  return {
    balanceD6: row.balance,
    remainingCostBasisNetD6: row.remainingCostBasisNetD6,
    claimRightsBalanceD6: row.claimRightsBalanceD6,
    realizedPnlD6: row.realizedPnlD6,
    realizedCostBasisD6: row.realizedCostBasisD6,
  };
}
